import { Award, ShieldCheck, Truck, Headset } from "lucide-react";
const guarantees = [{
  icon: Award,
  title: "IATA-Accredited Travel Agency — GoLite",
  description: "Circuitxtravel Ltd. operates as an IATA-accredited travel agency under the GoLite model, combining professional travel industry standards with personalized travel planning."
}, {
  icon: ShieldCheck,
  title: "Transparent Booking Coordination",
  description: "We help clients understand available booking options, relevant supplier terms, and payment arrangements so they can make informed travel decisions."
}, {
  icon: Truck,
  title: "Personalized Travel Coordination",
  description: "From hotels and cruises to selected experiences and transportation arrangements, we help coordinate travel plans according to each client's preferences and the availability of our travel partners."
}, {
  icon: Headset,
  title: "Dedicated Client Care",
  description: "One-to-one assistance from our team for questions, booking inquiries, and travel planning, through our official communication channels."
}];
export default function Globaltrustsecurity() {
  return <section data-section-id="257138" id="globaltrustsecurity" className="bg-background text-foreground w-full">
      <div className="bg-[#f5f1ed] py-16 px-4 md:px-8 border-y border-border/50">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {guarantees.map((item, i) => <div key={i} data-index={i} className="bg-white border border-border/40 rounded-lg p-8 flex flex-col items-center text-center transition-transform hover:-translate-y-1 duration-300 shadow-md shadow-primary/5">
                <div className="bg-[#1a365d]/5 p-4 rounded-lg mb-6">
                  <item.icon className="w-8 h-8 text-[#d4af37]" strokeWidth={1.5} />
                </div>
                <h3 className="text-[#1a365d] font-default font-bold text-xl mb-3 tracking-tight">
                  {item.title}
                </h3>
                <p className="text-muted-foreground font-sans text-sm leading-relaxed">
                  {item.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}